import { render, staticRenderFns } from "./EventState.vue?vue&type=template&id=0b989344"
import script from "./EventState.vue?vue&type=script&lang=js"
export * from "./EventState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports